<template>
  <div>
    <div
      v-if="dynamicBattleModel.myIndex !== null"
      class="battle-cover_room-id d-flex align-items-center justify-content-center pt-3 mt-3"
    >
      <div
        v-if="!hideRoom && dynamicBattleModel.type !== 'battle_royale'"
        class="position-relative w-75 d-flex flex-column"
      >
        <h2>{{ $t('_web_battle_room_label', 'Room ID(Max 50 char)') }}</h2>
        <div
          class="w-100 d-flex flex-row justify-content-between align-items-center"
        >
          <div v-if="dynamicBattleModel.battleInfo && !isEditing">
            <p class="room-info m-0">{{ dynamicBattleModel.battleInfo }}</p>
          </div>
          <HeraInput
            v-else
            v-model="roomId"
            class="w-100"
            :max-lenght="50"
            :placeholder="
              $t('_web_battle_room-placeholder', 'Room ID/ Match ID etc.:')
            "
            @keyup.enter.native="saveRoomId"
          />
          <div class="d-flex justify-content-around w-50">
            <AppIcon
              name="copy"
              :width="16"
              class="battle-cover_room-id-copy cursor-pointer"
              @click="copyRoomId"
            />
            <AppIcon
              name="edit"
              :width="16"
              class="battle-cover_room-id-copy cursor-pointer"
              @click="editRoomId"
            />
            <Btn
              v-if="!hideRoom && !room"
              :label="$t('Save')"
              :disabled="isSaveRoomDisabled"
              class="btn-accent-border"
              @click="saveRoomId"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex row wrapper-smaller-roster">
      <HeraDummyList
        v-if="!isLoading && isEmptyList"
        icon-name="group"
        position="center"
      >
        {{ $t('_web_battle-roster_empty-list', 'No data to show') }}
      </HeraDummyList>
      <HeraDummyList
        v-if="isLoading"
        class="position-relative pre-loader"
        position="center"
      />
      <template v-if="!isLoading">
        <div
          v-for="participant in account.players"
          :key="
            (participant && participant.profile && participant.profile.id) ||
              (participant && participant.profile && participant.profile.id)
          "
          class="col-6 roster-smaller"
        >
          <ParticipantsList
            v-if="participant"
            :player="participant.profile"
            :squads="participant.squad"
          />
        </div>
      </template>
      <!-- <div class="col-6">
      <ParticipantsList
        v-if="!isLoading && account.players[1]"
        :player="account.players[1].profile"
        :squads="account.players[1].squad"
      />
    </div> -->
      <!--    <div class="col-4">-->
      <!--      <Panel class="mt-5" variant="primary-card">-->
      <!--        -->
      <!--      </Panel>-->
      <!--    </div>-->
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
// import Panel from '@/components/atoms/Panel';
import { copyToClipboard } from '@/utils';
import ParticipantsList from './ParticipantsList';
import HeraDummyList from '@/components/common/HeraDummyList';
import HeraInput from '@/components/atoms/form/HeraFormTextInput';
import AppIcon from '@/components/atoms/Icon';
import Btn from '@/components/atoms/HeraFormBtn.vue';
export default {
  name: 'BattleRoster',
  components: {
    ParticipantsList,
    HeraDummyList,
    HeraInput,
    AppIcon,
    Btn,
    // Panel
  },
  props: {
    hideRoom: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: true,
      roomId: '',
      isEditing: false,
    };
  },
  computed: {
    ...mapState('current', ['account', 'accountId']),
    ...mapGetters(['dynamicBattleModel']),
    ...mapActions('updateBattleInfo', 'getBattleInfo'),
    isEmptyList() {
      return (
        !this.$lodash.get(this.account, 'players[0].squad.length') &&
        !this.$lodash.get(this.account, 'players[1].squad.length')
      );
    },
    isSaveRoomDisabled() {
      return this.roomId === this.dynamicBattleModel.battleInfo;
    },
    getRoomID() {
      return this.getBattleInfo(this.dynamicBattleModel.id);
    },
  },
  mounted() {
    this.isLoading = false;
  },
  methods: {
    ...mapActions(['updateBattleInfo', 'getBattleInfo']),
    // getRoomID() {
    //   this.getBattleInfo(this.dynamicBattleModel.if)
    // }
    saveRoomId() {
      if (this.isSaveRoomDisabled) {
        return;
      }
      // this.getBattleInfo(this.dynamicBattleModel.id);
      this.updateBattleInfo({
        battleId: this.dynamicBattleModel.id,
        battleInfo: this.roomId,
      }).catch(error => this.errorNotify(error));
      this.isEditing = false;
    },
    copyRoomId() {
      copyToClipboard(this.roomId || this.dynamicBattleModel.battleInfo);
    },
    editRoomId() {
      return (this.isEditing = true);
    },
  },
};
</script>

<style lang="scss">
.wrapper-smaller-roster {
  margin-top: 24px;
}
.room-info {
  width: 100%;
  font-size: 16px;
}
.input-battle-id {
  width: 100%;
  justify-self: center;
  max-width: 550px;
}
@media (max-width: 767px) {
  .roster-smaller {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
